import { useState } from "react"
import Button from "components/ui/Button"
import ContactSalesModal from "components/ContactSalesModal"
import Container from "components/ui/Container"
import Heading from "components/ui/Heading"

function HeroSection() {
  const [modalOpen, setModalOpen] = useState(false)
  return (
    <section className="relative bg-big-stone pb-16 pt-24 lg:pb-24 lg:pt-32">
      {/* Background image */}
      <div className="absolute left-0 top-0 h-full w-full">
        <img
          src="/images/content/BG_A.jpg"
          alt=""
          className="h-full w-full object-cover"
        />
      </div>
      <Container className="relative z-10">
        <div className="max-w-2xl">
          <div className="mb-5 inline-flex items-center gap-3 rounded-full bg-white/10 px-4 py-2">
            <img
              src="/images/pages/trust-and-security/compliance/hipaa.png"
              alt="HIPAA Compliant"
              className="h-6 w-auto"
            />
            <span className="text-sm font-semibold text-seafoam">
              HIPAA Compliant · BAA Available
            </span>
          </div>
          <Heading
            level="h1"
            title="HIPAA-Compliant Analytics for Healthcare Data"
            subtitle={
              <>
                Analyze healthcare data with confidence. Preset lets teams
                securely explore PHI with enterprise-grade security, governance,
                and access controls — your data stays in your warehouse.
              </>
            }
            size="large"
            inverted
          />
          <div className="mt-6 flex flex-col items-start gap-4 sm:flex-row sm:items-center">
            <Button
              color="green"
              size="medium"
              trackClick="Book a Demo (hero)_HIPAA Compliance"
              shadow
              onClick={() => setModalOpen(true)}
            >
              Book a Demo
            </Button>
            <p className="text-sm font-semibold text-seafoam">
              Free trial. No vendor lock-in.
            </p>
          </div>
          <a
            href="/trust-and-security/"
            className="mt-5 inline-block text-sm font-semibold text-seafoam underline decoration-seafoam/40 underline-offset-4 transition hover:decoration-seafoam"
          >
            Learn about our security →
          </a>
        </div>
      </Container>
      <ContactSalesModal
        isOpen={modalOpen}
        onClose={() => setModalOpen(false)}
        sourcePage="HIPAA Compliance - Hero"
      />
    </section>
  )
}

export default HeroSection
